import {
	JsonConvert,
	JsonConverter,
	JsonCustomConvert,
	JsonObject,
	JsonProperty,
} from "json2typescript";
import { BaseResponse } from "../../base-response";

@JsonConverter
export class LogConverter implements JsonCustomConvert<Log> {
	serialize() { }
	deserialize(data: any): Log {
		const jsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, Log);
	}
}
@JsonConverter
export class LogArrayConverter implements JsonCustomConvert<Array<Log>> {
	serialize() { }
	deserialize(data: any): Array<Log> {
		const jsonConvert = new JsonConvert();
		return jsonConvert.deserializeArray(data, Log);
	}
}

@JsonConverter
export class LogListConverter implements JsonCustomConvert<LogList> {
	serialize() { }
	deserialize(data: any): LogList {
		const jsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, LogList);
	}
}

@JsonObject("Log")
export class Log {
	@JsonProperty("timestamp", Number, true)
	timestamp: number = 0;
	@JsonProperty("mac_address", String, true)
	mac_address: string = "";
	@JsonProperty("username", String, true)
	username: string = "";
	@JsonProperty("result", String, true)
	result: string = "";
	@JsonProperty("reason", String, true)
	reason: string = "";
	@JsonProperty("message", String, true)
	message: string = "";
}

@JsonObject("LogList")
export class LogList {
	@JsonProperty("count", Number, true)
	count: number = 0;

	@JsonProperty("data", LogArrayConverter, true)
	data: Array<Log> = new Array<Log>();
}

@JsonObject("LogData")
export class LogData extends BaseResponse {
	@JsonProperty("data", LogConverter, true)
	data: Log = new Log();
}

@JsonObject("LogListData")
export class LogListData extends BaseResponse {
	@JsonProperty("data", LogListConverter, true)
	data: LogList = new LogList();
}